/** DEC Energy's founders, in the order the About page pairs them (Nicola left, Manuel right). */
export const FOUNDERS = [
  { name: "Nicola Scarinzi", jobTitle: "CEO & Co-Founder", href: "https://www.linkedin.com/in/nicolascarinzi/" },
  { name: "Manuel Bonù", jobTitle: "COO & Co-Founder", href: "https://www.linkedin.com/in/manuel-bonu/" },
] as const;
